import { AfterViewInit, Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Brand } from '@signal/asp-data-commons';
import { DateTime } from 'luxon';
import SignaturePad from 'signature_pad';
import { DeliveryChecklistService } from 'src/app/modules/shared/services/delivery-checklist.service';
import { UpdateSignatureFormData } from 'src/app/modules/store/delivery-checklist/delivery-checklist.actions';
import { DeliveryChecklistState, USER } from 'src/app/modules/store/delivery-checklist/delivery-checklist.reducer';
import { environment, userProfile } from '../../../shared/services/util.service';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements OnInit, AfterViewInit, OnDestroy {
  title = '';
  subTitle = 'deliveryChecklist.pleaseUseYourMouseOrDeviceToSignBelow';
  signatureSaveType = 'save'; 
  sigNatureObjct: any = {
    id: '',
    firstName: '',
    lastName: '',
    data: '',
    date: '',
    type: ''
  };
  disableSignaturePad = false;
  disableSaveInCanvas = true;
  disableClearIcon = false;
  disableElectronicSignature = false;
  certifyCheckBox = true;
  @ViewChild('sPad', { static: true }) signaturePadElement: any;
  signaturePad: any;
  showSpinner = false;
  disableInput = true;
  url;
  disable;
 USER = USER;
certifyText = '';
userProfile: any = userProfile;
signatureObjectData: any;
isLexus = environment.brand === Brand.LEXUS ;

  get checkSignature(): any {
    if (this.url) {
      return true;
    } else {
      return false;
    }
  }

  set checkSignature(value) {
    this.url = value;
  }

  get disableSaveAndSubmit(): any {
    if (this.disable) {
      return true;
    } else {
      return false;
    }
  }
  set disableSaveAndSubmit(value) {
    this.disable = value;
  }
  constructor(
    private readonly dialogRef: MatDialogRef<SignaturePadComponent>,
    private readonly deliveryChecklistState: Store<DeliveryChecklistState>,
    @Inject(MAT_DIALOG_DATA) public signatureInfo: any,
    private readonly digiChkService : DeliveryChecklistService,
    private readonly translate: TranslateService
  ) {
  }
   ngOnInit(): void {

    this.sigNatureObjct = this.signatureInfo?.sigData;
    this.signatureObjectData = {...this.sigNatureObjct};
    if (this.sigNatureObjct?.type === this.USER.TECHNICIAN) {
      this.title = 'deliveryChecklist.salesDeliveryConsultantSignature';
      this.certifyText = 'deliveryChecklist.consultantAcknowledgementMsg';
      this.disableInput = true;
if(this.sigNatureObjct.data) {
  this.onChange(true);
}
else {
  this.onChange(false);
}
    }
    if (this.sigNatureObjct?.type === this.USER.CUSTOMER) {
      this.title = 'deliveryChecklist.customerSignature';
      this.certifyText = this.translate.instant('deliveryChecklist.customerAcknowledgementMsg', {value: this.isLexus ? Brand.LEXUS : Brand.TOYOTA});
      this.disableInput = false;
      this.disableSignaturePad = false;
      this.disableElectronicSignature = true;
      this.disableSaveAndSubmit = true;
    }

    this.certify(this.certifyCheckBox);
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);
  }

  ngOnDestroy() {
    this.sigNatureObjct = {
      id: '',
      firstName: '',
      lastName: '',
      data: '',
      date: '',
      type: ''
    };
  }

  clear() {
    this.signaturePad.clear();
    if (this.signatureInfo?.sigData?.data && this.sigNatureObjct.type === this.USER.CUSTOMER) {
      this.sigNatureObjct = this.signatureInfo?.sigData
    } else {
      this.sigNatureObjct = {};
    }
    this.dialogRef.close({ sigNatureObjct: this.sigNatureObjct });
    this.checkSignature = "";
  }

  clearSigPad() {
    this.signaturePad.clear();
    this.disableSaveInCanvas = true;
    this.disableSaveAndSubmit = true;
    this.checkSignature = "";
    this.disableElectronicSignature = true;
    this.disableSignaturePad = false;
  }

  onChangeCheckbox($event) {
    if($event?.checked) {
      this.disableInput = true;
        this.sigNatureObjct.isSignatureExists = true;
        this.sigNatureObjct.data = this.signatureObjectData.data;
        this.sigNatureObjct.date = this.signatureObjectData.date;
        this.sigNatureObjct.id = this.signatureObjectData.id;
if(this.sigNatureObjct.data) {
  this.sigNatureObjct.isSignatureExists = true;
  this.onChange(true);
}else {
  this.sigNatureObjct.isSignatureExists = false;
  this.onChange(false);
    }
  }
    else {
      if(this.sigNatureObjct.data) {
        this.sigNatureObjct.isSignatureExists = false;
        this.sigNatureObjct.data = '';
        this.sigNatureObjct.date = '';
        this.sigNatureObjct.id = '';
        this.clearSigPad();
      }
      this.disableInput = true;
      this.onChange(false);
    }
  }

  onChange(checked) {
      this.disableSignaturePad = checked;
    if (this.disableSignaturePad) {
      this.signaturePad?.clear();
      this.disableElectronicSignature = false;
      this.disableClearIcon = true;
      if (this.sigNatureObjct.isSignatureCertified) {
        this.disableSaveAndSubmit = false;
      }
    } else {

      this.disableElectronicSignature = true;
      this.certifyCheckBox = false;
      this.disableClearIcon = false;
      this.disableSaveAndSubmit = true;
      if (this.checkSignature) {
        this.disableSaveAndSubmit = false;
      }
    }
  }

  certify($event) {
    if ($event) {
      this.certifyCheckBox = $event.checked
    } 
    else {
      this.certifyCheckBox = false
    }
    if (this.certifyCheckBox && (!this.signaturePad.isEmpty())) {
      this.disableSaveAndSubmit = false;
    } else if (this.certifyCheckBox && !this.disableElectronicSignature) {
      this.disableSaveAndSubmit = false;
    } else {
      this.disableSaveAndSubmit = true;
    }

  }

  signaturePadCanvas() {
    const dataURL = this.signaturePad.toDataURL();
    if (this.signaturePad._data.length > 0) {
      this.checkSignature = dataURL;
      this.disableSaveInCanvas = false;
      if (!this.sigNatureObjct.isSignatureCertified && this.sigNatureObjct.type !== this.USER.CUSTOMER) {
        this.disableSaveAndSubmit = true;
      } else {
        this.disableSaveAndSubmit = false;
      }
    }
  }

  async saveSignature(saveType?: string) {
    if (saveType === 'certify') {
      this.signatureSaveType = saveType;
    }
    if (!this.signaturePad.isEmpty()) {
      const dataURL =  this.signaturePad.toDataURL();
      this.sigNatureObjct.data = dataURL;

      if(!this.sigNatureObjct.isSignatureExists) {
        const sigData = { 
          data: this.sigNatureObjct.data,
          userId: '',
          ownerId: this.sigNatureObjct.ownerId ? this.sigNatureObjct.ownerId : '',
        }
        this.showSpinner = true;
        this.digiChkService.createSignature(sigData).subscribe(data=> {
          this.sigNatureObjct.id = data.userId;
          this.sigNatureObjct.date = DateTime.fromISO(data.metadata.createdAt).toFormat('MM/dd/yyyy');
          this.deliveryChecklistState.dispatch(new UpdateSignatureFormData({ value: this.sigNatureObjct }));
        this.showSpinner = false;
          this.dialogRef.close({ sigNatureObjct: this.sigNatureObjct, saveType: this.signatureSaveType });
        })
      }
      
    }
    else if(this.disableSignaturePad && this.sigNatureObjct.id){
      this.deliveryChecklistState.dispatch(new UpdateSignatureFormData({ value: this.sigNatureObjct }));
      this.showSpinner = false;
      this.dialogRef.close({ sigNatureObjct: this.sigNatureObjct, saveType: this.signatureSaveType });
    }
    }


}
